import type { Address } from '../types/location.types'

/**
 * An address as the detail screens print it: the street on one line, postcode and city on the
 * next. Lines without content are left out, and an address that already arrives as one string is
 * passed through as a single line.
 */
function formatAddressLines(address: Address | string | undefined): string[] {
  if (!address) {
    return []
  }

  if (typeof address === 'string') {
    return [address]
  }

  return [address.street, [address.postcode, address.city].filter(Boolean).join(' ')].filter((line): line is string =>
    Boolean(line),
  )
}

export { formatAddressLines }
